import * as faker from 'faker';

import * as helpers from './helpers';
import {orgs, defaultOrgId} from './organizations';

export const users = {};
export const defaultUserId = 23784;
const orgUsers = {};
let orgUserId = 15434;
for (let id = defaultUserId; id < defaultUserId + 78; id++) {
    const user = users[id] = {
        id,
        isDeleted: false,

        firstName: faker.name.firstName(),
        lastName: faker.name.lastName(),
        middleName: faker.name.firstName(),
        loginEmail: faker.internet.exampleEmail(),
        recoveryEmail: null,
        phone: faker.phone.phoneNumber('1(###) 555-01##'),

        eulaAccepted: true,

        orgUsers: [],
    };

    const orgBase = defaultOrgId + (id - defaultUserId);
    for (let orgId = orgBase; orgId > orgBase - 5; orgId--) {
        const org = orgs[orgId];
        if (!org) continue;

        const orgUser = {
            id: orgUserId++,
            active: true,
            isDeleted: false,

            userId: user.id,
            orgId: org.id,
            businessId: org.mainBusiness.id,
            role: 'Administrator',
            roleId: (
              orgId === orgBase
                ? 'ADMIN'
                : faker.random.arrayElement(['SHIPPER', 'QUOTER'])
            ),

            firstName: user.firstName,
            lastName: user.lastName,
            email: user.loginEmail,
            phone: user.phone,
        };

        orgUsers[orgUser.id] = orgUser;
        org.orgUsers.push(orgUser);
        user.orgUsers.push(orgUser);
    }
}
const defaultUser = users[defaultUserId];

function allOrgUsers(root, {orgId, orgIds}) {
    if (orgIds == null) {
        if (orgId == null) orgIds = defaultUser.orgUsers.map(u => u.orgId);
        else orgIds = [orgId];
    }
    return orgIds.reduce((a, id) => a.concat(orgs[id].orgUsers), []);
}

export const resolvers = {
    UserQueries: {
        byId: (root, {id}) => users[id],
        paged: helpers.pagedQuery(() => Object.values(users)),
    },

    UserAccessQueries: {
        me: () => ({
            user: users[defaultUserId],
            isPropelAdministrator: true,
            visibleOrganizations: [orgs[defaultOrgId]],
        }),

        // haven't needed these yet
        // everything has been bypassed by isPropelAdministrator
        permissions: (root, {orgId}) => [],
    },

    OrgUserQueries: {
        byId: (root, {id}) => orgUsers[id],
        all: allOrgUsers,
        paged: helpers.pagedQuery(allOrgUsers),
    },
};
